<template>
    <div class="share_info">
        <div class="title">
            <span>分享标题</span>
            <el-popover placement="right-end" trigger="hover" popper-class="shareTips">
                <div style="display:flex;justify-content: space-between;">
                    <img style="width:45%;height:auto;"  src="@/assets/image/sharetips2.png" />
                    <img style="width:45%;height:auto;" src="@/assets/image/sharetips1.png" />
                </div>
                <span slot="reference" style="color: #1989FA;text-decoration: underline; margin-left: 6px;">查看示例</span>
            </el-popover>
        </div>
        <div class="content">
            <template v-if="share_title">
                <el-input v-model="userInfo.share_title" placeholder="请输入修改分享标题" maxlength="32" show-word-limit class="basicInfo_inp" />
                <div class="oper">
                    <el-button size="small" @click="cancelEdit('share_title')">取消</el-button>
                    <el-button size="small" type="primary" @click="sureEdit('share_title')">确定</el-button>
                </div>
            </template>
            <template v-else>
                <p class="text">{{ userInfo.share_title }}</p>
                <p class="edit" @click="editInfo('share_title')">修改</p>
            </template>
        </div>
        <div class="tips">
            该标题为挂载讲师主页或全部在售课程时显示标题
        </div>
    </div>
</template>

<script>
import {
    mapState,
    mapActions
} from 'vuex'
export default {
    name: 'ShareInfo',
    data() {
        return {
            share_title: false,
        }
    },
    computed: {
        ...mapState('login', ['userInfo']),
    },
    created() {
        this.getUserInfo()
    },
    methods: {
        ...mapActions('login', ['getUserInfo', 'openpublicvisible', 'loginEditinfo']),
        cancelEdit(type) {
            this[type] = false
        },
        async sureEdit(type) {
            try {
                this[type] = false
                await this.loginEditinfo({ [type]: this.userInfo[type] })
                this.$message({
                    type: 'success',
                    duration: 3000,
                    message: '修改成功'
                })
            } catch (error) {

            }
        },
        editInfo(type) {
            this[type] = true
        },
    }
}
</script>

<style lang="less">
.shareTips{
           left: 454px!important;
           width: 60%;
        }
.share_info {
    width: 100%;
    padding: 0 30px;
    box-sizing: border-box;

    .title {
        width: 100%;
        font-size: 14px;
        text-align: left;

       

       
    }
     .showImg {
            display: flex;

            img {
                width: 26%;
                height: auto;
            }
        }

    .content {
        width: 100%;
        margin-top: 20px;
        display: flex;
        align-items: center;

        .text {
            width: 50%;
            min-height: 40px;
            border: 1px solid rgba(0, 0, 0, .2);
            line-height: 24px;
            padding-left: 20px;
            box-sizing: border-box;
            display: flex;
            align-items: center;
             font-size: 14px;
        }

        .edit {
           margin-left: 30px;
            font-size: 14px;
            color: #4e70f2;
            cursor: pointer;
            white-space: nowrap;
        }

        .basicInfo_inp {
            width: 50%;
            margin-right: 30px;
        }
    }

    .tips {
        width: 100%;
        margin: 0 auto;
        margin-top: 10px;
        text-align: left;
        font-size: 12px;
        color: rgba(0, 0, 0, .3);
    }
}
</style>